import { ReactElement, useState } from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

import Tab from './tab'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  tabs: {
    flexDirection: 'row',
  },
})

interface TabData {
  title: string
  disabled?: boolean
  accessory?: ReactElement
}

interface TabsViewInfo {
  index: number
  item: TabData
}

export interface Props extends ViewProps {
  data: TabData[]
  renderPage: (info: TabsViewInfo) => ReactElement
  initialSelected?: number
}

const TabsView = (props: Props) => {
  const { data, renderPage, initialSelected = 0, style, ...otherProps } = props
  const [selected, setSelected] = useState(initialSelected)

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.tabs}>
        {data.map((item, index) => (
          <Tab key={`Tab-${index}`} {...item} selected={selected === index} onPress={() => setSelected(index)} />
        ))}
      </View>
      {renderPage({ item: data[selected], index: selected })}
    </View>
  )
}

export default TabsView
